import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
  {
    path: 'callback',
    loadComponent: () =>
      import('./components/callback/callback.component').then(m => m.CallbackComponent)
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(m => m.LoginComponent)
  }
];
